<template>
    <keep-alive>
        <component :id="id" ref="comp" :is="currentComponent" @component-change="componentChange"/>
    </keep-alive>
</template>
<script>
    import {mapActions} from 'vuex'
    import compChannelList from './compChannelList'
    import compChannelConfig from './compChannelConfig'

    export default {
        components: {
            compChannelList,
            compChannelConfig
        },
        data() {
            return {
                id:'',
                currentComponent: compChannelList,
            }
        },
        methods: {
            ...mapActions('product', ['getIosChannelProductList']),
            componentChange({name, ...other}) {
                switch (name) {
                    case 'list':
                        this.currentComponent = compChannelList;
                        break;
                    case 'config':
                        this.id = other.id;
                        this.currentComponent = compChannelConfig;
                        break;
                    default:
                        break;
                }
            }
        }
    }
</script>